import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import * as moment from 'moment';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { Cart1Service } from '../services/cart1.service';
import { ConfigService } from '../services/config.service';
import { NotificationService } from '../services/notification.service';
import { OrderService } from '../services/order.service';
import { PaymentService } from '../services/payment.service';
import { ProductService } from '../services/product.service';
import { UserService } from '../services/user.service';
import { UtilityService } from '../services/utility.service';
import { PersistentService } from '../services/persistent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Item, CreateAutoOrder } from 'src/app/modals/createorderautoorder.modal';
import { ShipAddress } from 'src/app/modals/autoship.modal';
import { AccountService } from '../services/account.service';
import { AutoshipConfigurationService } from '../services/autoshipConfiguration.service';
import { RestApiService } from '../services/restapi.service';
import { ConfirmDialogComponent } from '../model/confirm-dialog/confirm-dialog.component';
import { ShipMethodsComponent } from '../model/ship-methods/ship-methods.component';
import { ShippingAddressDialogComponent } from '../model/shipping-address-dialog/shipping-address-dialog.component';
import { AllowCvvComponent } from '../model/allow-cvv/allow-cvv.component';
import { AddSymbolWithNumberPipe } from '../pipes/add-symbol-with-number.pipe';
import { CompanyService } from '../services/company.service';
import { LoginDialogComponentComponent } from '../login-dialog-component/login-dialog-component.component';
import { DefaultCountry, DefaultShipMethodID, EWALLET_MERCHANT_ID, CVV_REQUIRED_MERCHANT_IDS } from 'src/app/constant';
import { StoreConstantsService } from '../services/store-constants.service';
import { PaymentMethodSelectionDialogComponent } from '../model/payment-method-selection-dialog/payment-method-selection-dialog.component';
import { HostedpaymentDialogComponent } from '../model/hostedpayment-dialog/hostedpayment-dialog.component';

@Component({
  selector: 'app-autoship-edit',
  templateUrl: './autoship-edit.component.html',
  styleUrls: ['./autoship-edit.component.scss']
})
export class AutoshipEditComponent implements OnInit {
  userService: UserServiceModal;
  AutoOrderShippingAddress: any = {};
  editingAutoship: any = {};
  autoshipDate: any;
  autoShipId: number = 0;
  SelectedAutoshipPayment: any = {};
  selectedAutoship: any;
  autoshipDetail: any = {};
  IsMultipleFrequency: boolean = true;
  isStateRestrict: boolean = false;
  commonData: any = {};
  autoshipConfiguration: any = {
    setting: {
      disableEdit: false
    }
  };
  frequencyTypeID: number = 1;
  isDisabledCreateOrder: boolean = false;
  @Output() onAutoshipCancel = new EventEmitter<any>();
  item: any = {};
  getAutoshipOrderDetail: any;
  AutoshipSetting = [];
  lastQuantity: any;
  address: any;
  addressChanged: boolean;
  selectedShipMethodName: string;
  updateAutoOrderRequest: CreateAutoOrder;
  public AutoshipMinDate: Date;
  public AutoshipMaxDate: Date;
  constructor(
    public dialog: MatDialog,
    public configService: ConfigService,
    public notificationService: NotificationService,
    public apiService: RestApiService,
    public translate: TranslateService,
    public itemsService: ProductService,
    public cart1Service: Cart1Service,
    public orderService: OrderService,
    public user: UserService,
    public paymentService: PaymentService,
    public utilityService: UtilityService,
    public persistentService: PersistentService,
    public router: Router,
    public accountService: AccountService,
    public autoshipConfigurationService: AutoshipConfigurationService,
    public companyService: CompanyService,
    private route: ActivatedRoute,
    private storeConstantsService: StoreConstantsService,
    private cdr: ChangeDetectorRef
    ) {
    this.userService = user.userServiceModal;
    this.getAutoshipOrderDetail = this.persistentService.retailData.getAutoOrderDetailsByID;
    this.AutoshipMinDate = moment().add(this.configService.localSettings.Autoship.AutoshipMinDate, 'days').toDate();
    this.AutoshipMaxDate = moment().add(this.configService.localSettings.Autoship.AutoshipMaxDate, 'days').toDate();
    
    // Initialize frequency to monthly by default
    this.frequencyTypeID = 1;
  }

  ngOnInit(): void {
    this.commonData = this.configService.getConfig();
    this.userService.isAddressChanged = this.userService.isAddressChanged || false;
    this.userService.isPaymentChanged = this.userService.isPaymentChanged || false;
    this.userService.isShipMethodChanged = this.userService.isShipMethodChanged || false;
    this.address = this.address || {};
    this.persistentService.retailData.isChanged =
      this.persistentService.retailData.AddMoreItemInAutoshipFlag ||
      this.utilityService.getAutoshipEditFlag() ||
      false;
    
    // Ensure frequency defaults to monthly (ID: 1) if not set
    if (!this.persistentService.retailData.Autoship.FrequencyTypeID) {
      this.persistentService.retailData.Autoship.FrequencyTypeID = 1;
      this.persistentService.retailData.Autoship.FrequencyTypeDescription = 'Monthly';
    }
    // Select Autoship Types
    this.persistentService.retailData.isNewAutoship = this.persistentService.retailData.isNewAutoship || false;
    // Show selected Autoship in dropdown
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      const isPaid = params['ispaid'];
      this.persistentService.retailData.getAutoOrderDetailsByID = {
        id: id,
        isPaid: isPaid,
      };
      this.getAutoshipOrderDetail = this.persistentService.retailData.getAutoOrderDetailsByID;
      this.selectedAutoship = this.persistentService.retailData.getAutoOrderDetailsByID?.id;
      // Set CurrentSelectedAutoOrder from query params to ensure it survives page refresh
      if (id) {
        this.persistentService.retailData.CurrentSelectedAutoOrder = id;
      }
    });
    // Get Saved & Allowed Payment Methods
    this.persistentService.retailData.IsPaid = false;
    this.paymentService.getPaymentType().then(() => {
      if (!this.persistentService.retailData.AddMoreItemInAutoshipFlag) {
        this.editAutoship();
      } else {
        // Use query params ID if available, otherwise fall back to AddMoreItemInAutoshipData
        const autoshipIdFromUrl = this.selectedAutoship || this.getAutoshipOrderDetail?.id;

        if (autoshipIdFromUrl) {
          // Ensure getAutoshipOrderDetail has the correct id from URL
          this.getAutoshipOrderDetail = {
            ...this.persistentService.retailData.AddMoreItemInAutoshipData,
            id: autoshipIdFromUrl
          };
        } else {
          this.getAutoshipOrderDetail = this.persistentService.retailData.AddMoreItemInAutoshipData;
        }

        this.frequencyTypeID = this.persistentService.retailData.Autoship.FrequencyTypeID || 1;
        this.editingAutoship.AutoOrderID = this.getAutoshipOrderDetail?.id;

        if (this.userService.paymentMethods.length > 0) {
          const paymentData = this.userService.paymentMethods[0];
          this.paymentService.selectedPaymentTypeName = (paymentData.DisplayName || paymentData.CardType) +
            ' ' +
            (paymentData.Ending ? paymentData.Ending : (paymentData.Last4 ? paymentData.Last4 : '')) || this.translate.instant('add_a_payment_method');
        }
        this.orderService.calculateAutoOrder();
      }
    });
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

  editAutoship() {
    this.autoShipId = this.getAutoshipOrderDetail.id;
    this.itemsService.selectedAutoOrderItems = [];
    this.persistentService.retailData.IsPaid = this.getAutoshipOrderDetail.isPaid;
    this.persistentService.retailData.CurrentSelectedAutoOrder = this.getAutoshipOrderDetail.id;

    // Initial steps of Payment Functionality - Don't clear payment methods yet
    // They will be properly populated after loading autoship details
    this.persistentService.retailData.SelectedAutoshipPayment = {};
    this.paymentService.selectedPaymentTypeName = this.translate.instant('Add_Payment_Method');
    // REMOVED: this.userService.paymentMethods = []; - Will be populated from autoship data
    this.paymentService.SelectedPaymentTypes = {};

    const AutoOrderId = this.getAutoshipOrderDetail.id;

    this.apiService.getAutoship(AutoOrderId).subscribe((result) => {
      if (!result.Data || result.Data.AutoShipID <= 0) {
        this.notificationService.error('Error', this.translate.instant('some_error_occur_try_again'));
        return false;
      }
      this.persistentService.retailData.Autoship = {};
      this.editingAutoship = result.Data;
      this.autoshipDetail = result.Data;

      // Initialize frequency - use existing frequency or default to monthly (ID: 1)
      if (this.editingAutoship.Frequency) {
        this.frequencyTypeID = this.editingAutoship.Frequency;
        this.persistentService.retailData.Autoship.FrequencyTypeID = this.editingAutoship.Frequency;
        this.persistentService.retailData.Autoship.FrequencyTypeDescription = this.editingAutoship.FrequencyString;
      } else {
        this.frequencyTypeID = 1; // Monthly default
        this.persistentService.retailData.Autoship.FrequencyTypeID = 1;
        this.persistentService.retailData.Autoship.FrequencyTypeDescription = 'Monthly';
      }

      // Fill Shipping Address on only Temp basis while editing autoship
      this.AutoOrderShippingAddress = {};
      this.AutoOrderShippingAddress.FirstName = this.editingAutoship.ShipAddress.FirstName;
      this.AutoOrderShippingAddress.LastName = this.editingAutoship.ShipAddress.LastName;
      this.AutoOrderShippingAddress.Address = this.editingAutoship.ShipAddress.Street1;
      this.AutoOrderShippingAddress.Address2 = this.editingAutoship.ShipAddress.Street2;
      this.AutoOrderShippingAddress.City = this.editingAutoship.ShipAddress.City;
      this.AutoOrderShippingAddress.State = this.editingAutoship.ShipAddress.Region;
      this.AutoOrderShippingAddress.Country = this.editingAutoship.ShipAddress.CountryCode;
      this.AutoOrderShippingAddress.ZipCode = this.editingAutoship.ShipAddress.PostalCode;

      // Fill Start Date
      // **In case of edit an Autoship, We will show next run date as start date by default */
      this.autoshipConfigurationService.autoshipDate = this.editingAutoship.NextProcessDate || this.editingAutoship.StartDate;
      this.persistentService.retailData.autoshipDate = this.editingAutoship.NextProcessDate || this.editingAutoship.StartDate;
      
      // Initialize autoshipDate for the date picker
      if (this.editingAutoship.NextProcessDate || this.editingAutoship.StartDate) {
        this.autoshipDate = moment(this.editingAutoship.NextProcessDate || this.editingAutoship.StartDate).toDate();
      } else {
        this.autoshipDate = moment().toDate();
      }

      // If NextRun Date is Past Date, set it to default Autoship date
      if (new Date(this.autoshipConfigurationService.autoshipDate) < new Date()) {
        this.autoshipConfigurationService.autoshipDate = '';
        this.autoshipDate = moment().toDate();
      }

      this.userService.selectedShippingMethod = this.editingAutoship.ShipMethodID;
      if (this.AutoOrderShippingAddress || Object.keys(this.AutoOrderShippingAddress).length > 0) {
        this.userService.shippingAddress.FirstName = this.editingAutoship.ShipAddress.FirstName;
        this.userService.shippingAddress.LastName = this.editingAutoship.ShipAddress.LastName;
        this.userService.shippingAddress.Street1 = this.editingAutoship.ShipAddress.Street1;
        this.userService.shippingAddress.Street2 = this.editingAutoship.ShipAddress.Street2;
        this.userService.shippingAddress.City = this.editingAutoship.ShipAddress.City;
        this.userService.shippingAddress.Region = this.editingAutoship.ShipAddress.Region;
        this.userService.shippingAddress.CountryCode = this.editingAutoship.ShipAddress.CountryCode;
        this.userService.shippingAddress.PostalCode = this.editingAutoship.ShipAddress.PostalCode;
      }
      let bvTotal = 0;
      _.each(result.Data.LineItems, (item) => {
        item.AutoOrderID = result.Data.AutoShipID;
        item.ItemID = item.ItemID.toString();
        item.Description = item.ItemDescription || item.Description;
        item.ItemName = item.ItemDescription || item.ProductName;
        item.Price = item?.PriceEach || item?.Prices?.[0]?.Price || item?.Price || item?.ExtendedPrice;
        item.AutoshipPrice = item?.PriceEach || item?.Prices?.[0]?.Price || item?.Price || item?.ExtendedPrice;
        item.PV = item.BVEach || item.QV;
        item.BusinessVolumeEach = item.PV || item.CV;
        item.ImageUrl = item.Image;
        item.SmallImageUrl = item.SmallPicture || item.Image;
        item.LargeImageUrl = item.SmallPicture || item.Image;
        item.ShortDescription = item.ShortDetail || item.Specifications;
        item.isAutoship = true;
        item.OptionsMap = [];
        this.itemsService.selectedAutoOrderItems.push(item);
        bvTotal += Number(item.BV * item.Quantity);
      });
      _.each(this.itemsService.selectedAutoOrderItems, (item) => {
        _.each(this.itemsService.orders, (listItem) => {
          if (item.ItemID == listItem.ItemID) {
            item.AllowAutoship = listItem.AllowAutoship;
          } else if (listItem.HasOptions) {
            const optionMap = listItem.OptionsMap;
            _.each(listItem.OptionsMap, (value) => {
              if (value.ItemId == item.ItemID) {
                item.AllowAutoship = value.AllowAutoship == undefined ? listItem.AllowAutoship : value.AllowAutoship;
              }
            });
          }
        });
      });
      localStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));

      // payment details for autoorder
      // Clear payment methods array to ensure clean state before populating
      this.userService.paymentMethods = [];

      const paymentMerchantID = this.editingAutoship.PaymentMerchantID || this.editingAutoship.PaymentMerchantId;
      const paymentMethodID = this.editingAutoship.PaymentMethodID;

      const isEwalletFromAPI = paymentMerchantID === EWALLET_MERCHANT_ID ||
                                paymentMerchantID === EWALLET_MERCHANT_ID.toString() ||
                                (paymentMethodID && (parseInt(paymentMethodID, 10) === EWALLET_MERCHANT_ID || paymentMethodID === EWALLET_MERCHANT_ID.toString()));

      this.persistentService.retailData.SelectedAutoshipPayment.PaymentTypeID = paymentMethodID;
      
      if (isEwalletFromAPI) {
        const ewalletPaymentMethod = {
          CardType: 'E-Wallet',
          Ending: 'WALLET',
          Last4: 'WALLET',
          PaymentMethodId: paymentMethodID || EWALLET_MERCHANT_ID.toString(),
          Token: paymentMethodID || EWALLET_MERCHANT_ID.toString(),
          MerchantId: EWALLET_MERCHANT_ID,
          NameOnAccount: 'E-Wallet',
          DisplayName: 'E-Wallet',
          Name: 'E-Wallet',
          Expires: null,
          ExpireMonth: 0,
          ExpireYear: 0
        };
        
        this.persistentService.retailData.SelectedAutoshipPayment = {
          ...ewalletPaymentMethod,
          PaymentTypeID: paymentMethodID || EWALLET_MERCHANT_ID.toString(),
          PaymentDisplay: 'E-Wallet'
        };
        this.paymentService.SelectedPaymentTypes = ewalletPaymentMethod;
        this.paymentService.selectedPaymentTypeName = 'E-Wallet';
        
        this.userService.paymentMethods = [ewalletPaymentMethod];
        localStorage.setItem('userService', JSON.stringify(this.userService));
      } else if (this.paymentService.PaymentTypeResponse['SaveMethods']?.length > 0) {
        if (this.persistentService.retailData.SelectedAutoshipPayment.PaymentTypeID) {

          const paymentMethodIDNum = typeof paymentMethodID === 'string' ? parseInt(paymentMethodID, 10) : paymentMethodID;
          
          let selectedAutoOrderPay = _.filter(this.paymentService.PaymentTypeResponse['SaveMethods'], (paymentMethod) => {
            if (paymentMethod.PaymentMethodId == paymentMethodID) {
              return true;
            }
            if (paymentMethod.MerchantId === EWALLET_MERCHANT_ID && 
                (paymentMethodIDNum === EWALLET_MERCHANT_ID || paymentMethodID === EWALLET_MERCHANT_ID.toString())) {
              return true;
            }
            const methodPaymentMethodIdNum = typeof paymentMethod.PaymentMethodId === 'string' 
              ? parseInt(paymentMethod.PaymentMethodId, 10) 
              : paymentMethod.PaymentMethodId;
            if (methodPaymentMethodIdNum === paymentMethodIDNum && !isNaN(paymentMethodIDNum)) {
              return true;
            }
            return false;
          })[0];

          if (selectedAutoOrderPay) {
            this.persistentService.retailData.SelectedAutoshipPayment = selectedAutoOrderPay;
            this.paymentService.SelectedPaymentTypes = selectedAutoOrderPay;
            if (selectedAutoOrderPay.MerchantId === EWALLET_MERCHANT_ID || selectedAutoOrderPay.CardType === 'E-Wallet') {
              this.paymentService.selectedPaymentTypeName = 'E-Wallet';
            } else {
              this.paymentService.selectedPaymentTypeName =
                (selectedAutoOrderPay.DisplayName || selectedAutoOrderPay.CardType) +
                ' ' +
                (selectedAutoOrderPay.Ending ? selectedAutoOrderPay.Ending : '') || this.translate.instant('add_a_payment_method');
            }
            
            const selectpay = {
              CardType: this.paymentService.SelectedPaymentTypes.CardType,
              Ending: this.paymentService.SelectedPaymentTypes.Ending,
              Last4: this.paymentService.SelectedPaymentTypes.Ending,
              Expires: this.paymentService.SelectedPaymentTypes.Expires,
              ExpireMonth: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('M') : 0,
              ExpireYear: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('YYYY') : 0,
              NameOnAccount: this.paymentService.SelectedPaymentTypes.NameOnAccount || this.paymentService.SelectedPaymentTypes.Name,
              Token: this.paymentService.SelectedPaymentTypes.PaymentMethodId ? this.paymentService.SelectedPaymentTypes.PaymentMethodId : '',
              PaymentMethodId: this.paymentService.SelectedPaymentTypes.PaymentMethodId ? this.paymentService.SelectedPaymentTypes.PaymentMethodId : '',
              MerchantId: this.paymentService.SelectedPaymentTypes.MerchantId
            };
            this.userService.paymentMethods.push(selectpay);

            localStorage.setItem('userService', JSON.stringify(this.userService));
          } else {
            if (paymentMethodIDNum === EWALLET_MERCHANT_ID || paymentMethodID === EWALLET_MERCHANT_ID.toString()) {
              const ewalletPaymentMethod = {
                CardType: 'E-Wallet',
                Ending: 'WALLET',
                Last4: 'WALLET',
                PaymentMethodId: EWALLET_MERCHANT_ID.toString(),
                Token: EWALLET_MERCHANT_ID.toString(),
                MerchantId: EWALLET_MERCHANT_ID,
                NameOnAccount: 'E-Wallet',
                DisplayName: 'E-Wallet',
                Name: 'E-Wallet',
                Expires: null,
                ExpireMonth: 0,
                ExpireYear: 0
              };
              
              this.persistentService.retailData.SelectedAutoshipPayment = {
                ...ewalletPaymentMethod,
                PaymentTypeID: EWALLET_MERCHANT_ID.toString(),
                PaymentDisplay: 'E-Wallet'
              };
              this.paymentService.SelectedPaymentTypes = ewalletPaymentMethod;
              this.paymentService.selectedPaymentTypeName = 'E-Wallet';
              
              this.userService.paymentMethods = [ewalletPaymentMethod];
              localStorage.setItem('userService', JSON.stringify(this.userService));
            } else {
              this.setDefaultAutoshipPayment();
            }
          }

        } else {
          this.setDefaultAutoshipPayment();
        }
      } else {
        const paymentMerchantID = this.editingAutoship.PaymentMerchantID || this.editingAutoship.PaymentMerchantId;
        const paymentMethodID = this.editingAutoship.PaymentMethodID;
        const isEwalletFromAPI = paymentMerchantID === EWALLET_MERCHANT_ID || 
                                  paymentMerchantID === EWALLET_MERCHANT_ID.toString() ||
                                  (paymentMethodID && (parseInt(paymentMethodID, 10) === EWALLET_MERCHANT_ID || paymentMethodID === EWALLET_MERCHANT_ID.toString()));
        
        if (isEwalletFromAPI) {
          const ewalletPaymentMethod = {
            CardType: 'E-Wallet',
            Ending: 'WALLET',
            Last4: 'WALLET',
            PaymentMethodId: paymentMethodID || EWALLET_MERCHANT_ID.toString(),
            Token: paymentMethodID || EWALLET_MERCHANT_ID.toString(),
            MerchantId: EWALLET_MERCHANT_ID,
            NameOnAccount: 'E-Wallet',
            DisplayName: 'E-Wallet',
            Name: 'E-Wallet',
            Expires: null,
            ExpireMonth: 0,
            ExpireYear: 0
          };
          
          this.persistentService.retailData.SelectedAutoshipPayment = {
            ...ewalletPaymentMethod,
            PaymentTypeID: paymentMethodID || EWALLET_MERCHANT_ID.toString(),
            PaymentDisplay: 'E-Wallet'
          };
          this.paymentService.SelectedPaymentTypes = ewalletPaymentMethod;
          this.paymentService.selectedPaymentTypeName = 'E-Wallet';
          
          this.userService.paymentMethods = [ewalletPaymentMethod];
          localStorage.setItem('userService', JSON.stringify(this.userService));
        } else {
          this.persistentService.retailData.SelectedAutoshipPayment = [];
          this.paymentService.selectedPaymentTypeName = this.translate.instant('Add_Payment_Method');
          localStorage.setItem('userService', JSON.stringify(this.userService));
        }
      }
      this.cart1Service.setQuantiy();

      this.orderService.calculateAutoOrder().then(() => {
        this.orderService.calculateAutoOrderResponse['BusinessVolumeTotal'] = this.editingAutoship.TotalCV;
      });

      this.persistentService.retailData.editAutoshipItems = cloneDeep(this.itemsService.selectedAutoOrderItems);
      this.utilityService.setAutoshipEditFlag(true);
      this.autoshipConfigurationService.init();
    }, (error) => {
      // Handle error silently
    }, () => {

    });
  }

  getLastQuantity(type, item) {
    this.lastQuantity = this.getQuantityModel(type, item)[item.ItemID];
  }

  /**
   * Set Autoship Frequency
   * Updates the frequency type for the autoship subscription
   * @param frequencyTypeID - The ID of the selected frequency type
   */
  setFrequency(frequencyTypeID) {
    this.commonData.FrequencyTypes.some((freq) => {
      if (freq.ID == frequencyTypeID) {
        this.persistentService.retailData.Autoship.FrequencyTypeDescription = freq.Description;
        this.persistentService.retailData.Autoship.FrequencyTypeID = freq.ID;
        this.editingAutoship.Frequency = freq.ID;
        this.editingAutoship.FrequencyString = freq.Description;
        this.persistentService.retailData.isChanged = true;
        return;
      }
    });
  }

  setDefaultAutoshipPayment() {
    if (!this.paymentService.PaymentTypeResponse['SaveMethods'] || this.paymentService.PaymentTypeResponse['SaveMethods'].length === 0) {
      return;
    }
    
    this.persistentService.retailData.SelectedAutoshipPayment = this.paymentService.PaymentTypeResponse['SaveMethods'][0];
    this.paymentService.SelectedPaymentTypes = this.persistentService.retailData.SelectedAutoshipPayment;
    
    const selectedPayment = this.persistentService.retailData.SelectedAutoshipPayment;
    if (selectedPayment.MerchantId === EWALLET_MERCHANT_ID || selectedPayment.CardType === 'E-Wallet') {
      this.paymentService.selectedPaymentTypeName = 'E-Wallet';
    } else {
      this.paymentService.selectedPaymentTypeName = selectedPayment.CardType + ' ' + (selectedPayment.Ending || '');
    }
    
    const selectpay = {
      CardType: this.paymentService.SelectedPaymentTypes.CardType,
      Ending: this.paymentService.SelectedPaymentTypes.Ending,
      Last4: this.paymentService.SelectedPaymentTypes.Ending,
      Expires: this.paymentService.SelectedPaymentTypes.Expires,
      ExpireMonth: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('M') : 0,
      ExpireYear: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('YYYY') : 0,
      NameOnAccount: this.paymentService.SelectedPaymentTypes.NameOnAccount || this.paymentService.SelectedPaymentTypes.Name,
      Token: this.paymentService.SelectedPaymentTypes.PaymentMethodId ? this.paymentService.SelectedPaymentTypes.PaymentMethodId : '',
      PaymentMethodId: this.paymentService.SelectedPaymentTypes.PaymentMethodId ? this.paymentService.SelectedPaymentTypes.PaymentMethodId : '',
      MerchantId: this.paymentService.SelectedPaymentTypes.MerchantId
    };
    this.userService.paymentMethods.push(selectpay);

    localStorage.setItem('userService', JSON.stringify(this.userService));
  }

  editAutoshipFrequency(event) {
    if (event && event.value) {
      const selectedDate = event.value; // This is already a Date object
      this.persistentService.retailData.isChanged = true;
      
      // Update the component property for two-way binding
      this.autoshipDate = selectedDate;
      
      // Update service properties using moment for formatting
      this.autoshipConfigurationService.autoshipDate = moment(selectedDate).format('YYYY-MM-DD');
      this.editingAutoship.NextProcessDate = moment(selectedDate).format('YYYY-MM-DD');
      
      // Update persistent service
      this.persistentService.retailData.autoshipDate = moment(selectedDate).format('YYYY-MM-DD');
      
      // Trigger change detection
      this.persistentService.setRetailData();
      
      // Force change detection
      this.cdr.detectChanges();
    }
  }


  getAddress(response) {
    this.persistentService.retailData.isChanged = true;
    if (this.userService.shippingAddress.CountryCode.toLowerCase() !== response.address.Country.toLowerCase()) {
      this.addressChanged = true;
    }
    this.persistentService.retailData.isNewAddress = response.address;
    this.userService.shippingAddress.FirstName = response.address.FirstName;
    this.userService.shippingAddress.LastName = response.address.LastName;
    this.userService.shippingAddress.Street1 = response.address.Address1;
    this.userService.shippingAddress.Street2 = response.address.Address2;
    this.userService.shippingAddress.City = response.address.City;
    this.userService.shippingAddress.Region = response.address.State;
    this.userService.shippingAddress.CountryCode = response.address.Country;
    this.userService.shippingAddress.PostalCode = response.address.Zip;

    if (response.isReplacement) {
      this.address.replaceDefault = true;
      this.persistentService.retailData.isAddresschanged = true;
    } else {
      this.persistentService.retailData.isAddresschanged = false;
    }
    // Order calculations may change based on the shipping Address
    this.orderService.calculateAutoOrder();
  }

  decreaseQuantiy(item) {
    if (this.itemsService.selectedAutoOrderItems.length == 1 && this.itemsService.selectedAutoOrderItems[0].Quantity == 1) {
      if (this.AutoshipSetting['IsShowDeleteAutoship']) {
        this.deleteAutoship();
      } else {
        const dialog = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: '400px',
          data: {
            title: this.translate.instant('trying_delete_autoship'),
            message: this.translate.instant('prevent_delete_autoship_message'),
            takeaction: this.translate.instant('got_it'),
            noaction: '',
          },
          panelClass: '',
          disableClose: true
        });
        dialog.afterClosed().subscribe((result) => {
          if (result) {
            this.persistentService.retailData.isChanged = true;
          }
        });
      }
    } else {
      this.cart1Service.decreaseQuantiy(item, true, false);
    }
  }

  clearCart() {
    this.cart1Service.autoshipQuantity = {};
    this.itemsService.selectedAutoOrderItems = [];
    this.orderService.calculateAutoOrderResponse = {};
    localStorage.removeItem('cart.autoship');
  }

  cancelAutoship() {
    this.utilityService.setAutoshipEditFlag(false);
    this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
    this.persistentService.retailData.isAutoshipEdit = false;
    this.persistentService.retailData.AddMoreItemInAutoshipData = {};
    this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
    this.clearCart();
    this.orderService.calculateAutoOrder();
  }

  getAutoshipFrequency() {
    return this.persistentService.retailData.Autoship && this.persistentService.retailData.Autoship.FrequencyTypeDescription;
  }

  getAutoshipStartDate() {
    if (this.autoshipDate) {
      return this.autoshipDate;
    } else if (this.autoshipConfigurationService.autoshipDate) {
      return moment(this.autoshipConfigurationService.autoshipDate).toDate();
    } else {
      return moment().toDate();
    }
  }

  getShipMethodName() {
    if (this.orderService.calculateAutoOrderResponse?.ShippingMethods) {
      const selectedShipMethods = _.find(this.orderService.calculateAutoOrderResponse.ShippingMethods, (item) => {
        return item.ShipMethodId == this.userService.selectedShippingMethod;
      });
      if (selectedShipMethods && !this.utilityService.isEmptyObject(selectedShipMethods)) {
        this.selectedShipMethodName = selectedShipMethods.Description;
      }
      return this.selectedShipMethodName;
    }
  }

  getQuantityModel(type, item): any {
    return this.cart1Service[type == 'pack' ? 'packQuantity' : (type == 'autoship' ? 'autoshipQuantity' : ((item && item.UsePoints) ? 'orderRewardQuantity' : 'orderQuantity'))];
  }


  checkQuantity(type, item) {
    const quantity = this.getQuantityModel(type, item)[item.ItemID];
    if (!Number(quantity)) {
      this.getQuantityModel(type, item)[item.ItemID] = 1;
    } else {
      item.Quantity = quantity;
      if (type == 'autoship') {
        this.persistentService.retailData.isChanged = true;
        localStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));
        this.orderService.calculateAutoOrder();
      } else {
        localStorage.setItem((type == 'pack' ? 'cart.packs' : 'cart.order'), JSON.stringify(type == 'pack' ? this.itemsService.selectedPacks : this.itemsService.selectedOrderItems));
        this.orderService.calculateOrder();
      }
    }
  }

  editAutoshipShippingMethod() {
    const dialog = this.dialog.open(ShipMethodsComponent, {
      // width: '600px',
      // maxWidth: '600px',
      data: this.orderService.calculateAutoOrderResponse.ShippingMethods,
      panelClass: 'shippingmethodDialog'
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.getShipMethod(result);
      }
    });
  }
  editAutoshipShippingAddress() {

    const dialog = this.dialog.open(ShippingAddressDialogComponent, {
      width: '600px',
      maxWidth: '600px',
      panelClass: 'shippingAddressDialog'
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        if (result && result.isReplacement) {
          this.userService.shippingAddress.FirstName = result.address.FirstName;
          this.userService.shippingAddress.LastName = result.address.LastName;
          this.userService.shippingAddress.Street1 = result.address.Street1;
          this.userService.shippingAddress.Street2 = result.address.Street2;
          this.userService.shippingAddress.City = result.address.City;
          this.userService.shippingAddress.Region = result.address.Region;
          this.userService.shippingAddress.CountryCode = result.address.CountryCode;
          this.userService.shippingAddress.PostalCode = result.address.PostalCode;
          this.persistentService.retailData.isChanged = true;
          this.orderService.calculateAutoOrder();
        }
      }
    });
  }

  getShipMethod(newShippingMethod) {
    this.persistentService.retailData.isChanged = true;
    this.userService.selectedShippingMethod = newShippingMethod.shipMethod;
    this.orderService.calculateAutoOrder();
  }

  deleteItem(item) {
    if (this.itemsService.selectedAutoOrderItems && this.itemsService.selectedAutoOrderItems.length > 1) {
      this.persistentService.retailData.isChanged = true;
      this.cart1Service.removeFromCart(item, true, false, true);
    } else if (this.itemsService.selectedAutoOrderItems && this.itemsService.selectedAutoOrderItems.length == 1) {
      if (this.AutoshipSetting['IsShowDeleteAutoship']) {
        this.deleteAutoship();
      } else {

        const dialog = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: '400px',
          data: {
            title: this.translate.instant('trying_delete_autoship'),
            message: this.translate.instant('prevent_delete_autoship_message'),
            takeaction: this.translate.instant('got_it'),
            noaction: '',
          },
          panelClass: '',
          disableClose: true
        });
        dialog.afterClosed().subscribe((result) => {
          if (result) {
          }
        });
      }
    }
  }

  deleteAutoship() {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: {
        title: this.translate.instant('delete_autoship_title'),
        message: this.translate.instant('delete_autoship_text'),
        takeaction: this.translate.instant('YES'),
        noaction: this.translate.instant('NO'),
      },
      panelClass: '',
      disableClose: true
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.apiService.deleteAutoship(this.persistentService.retailData.CurrentSelectedAutoOrder).subscribe((result) => {
          try {
            if (result && Number(result.Status) === 1) {
              this.utilityService.setAutoshipEditFlag(false);
              this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
              this.persistentService.retailData.AddMoreItemInAutoshipData = {};
              this.persistentService.retailData.editAutoshipItems = [];
              this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
              this.router.navigate(['/manageautoship']);
              this.notificationService.success('Success', this.translate.instant('successfully_deleted'));
              this.persistentService.retailData.isAutoshipEdit = false;
              this.cart1Service.clearCart();
            } else {
              this.notificationService.error('error_', this.translate.instant('some_error_occur_try_again'));
            }
          } catch (ex) {
            this.notificationService.error('error_', this.translate.instant('Delete Autoship Error'));
          }

        }, (error) => {
          this.notificationService.error('error_', this.translate.instant('Delete Autoship Error'));
        }, () => {
        });
      }
    });
  }

  // Save Payment Method
  addSavePayment(paymentData) {
    this.persistentService.retailData.isChanged = true;

    const isEwallet = paymentData.MerchantId === EWALLET_MERCHANT_ID ||
                      paymentData.CardType === 'E-Wallet' ||
                      paymentData.Ending === 'WALLET';

    // FIX: Don't clear payment methods when merchant changes
    // Instead, we'll replace the array with the new payment method below
    // This prevents the "Select Merchant" dialog from appearing
    // if (this.paymentService.SelectedPaymentTypes && (this.paymentService.SelectedPaymentTypes.MerchantId !== paymentData.MerchantId)) {
    //   this.userService.paymentMethods = [];
    // }

    this.paymentService.SelectedPaymentTypes = paymentData;
    
    if (isEwallet) {
      this.paymentService.selectedPaymentTypeName = 'E-Wallet';
    } else {
      this.paymentService.selectedPaymentTypeName =
        (paymentData.DisplayName || paymentData.CardType) +
        ' ' +
        (paymentData.Ending ? paymentData.Ending : '') || this.translate.instant('add_a_payment_method');
    }

    if (isEwallet) {
      this.userService.paymentMethods = [];
      
      const ewalletPayment = {
        ...paymentData,  
        CardType: 'E-Wallet',  
        Ending: paymentData.Ending || 'WALLET',
        Last4: paymentData.Last4 || paymentData.Ending || 'WALLET',
        PaymentMethodId: paymentData.PaymentMethodId || paymentData.MerchantId?.toString() || EWALLET_MERCHANT_ID.toString(),
        Token: paymentData.Token || paymentData.PaymentMethodId || paymentData.MerchantId?.toString() || EWALLET_MERCHANT_ID.toString(),
        MerchantId: paymentData.MerchantId || EWALLET_MERCHANT_ID,
        NameOnAccount: paymentData.NameOnAccount || paymentData.Name || '',
        Expires: paymentData.Expires || null,
        ExpireMonth: paymentData.ExpireMonth || 0,
        ExpireYear: paymentData.ExpireYear || 0
      };
      
      this.userService.paymentMethods = [ewalletPayment];
      this.userService.isPaymentChanged = true;
      this.paymentService.OldSelectedPaymentType = this.paymentService.SelectedPaymentTypes;
      
      this.persistentService.retailData.SelectedAutoshipPayment = {
        ...ewalletPayment,
        PaymentTypeID: ewalletPayment.PaymentMethodId,
        PaymentDisplay: 'E-Wallet',
        DisplayName: 'E-Wallet',
        Name: 'E-Wallet'
      };
      
      localStorage.setItem('userService', JSON.stringify(this.userService));
      
      this.cdr.detectChanges();
      
      this.notificationService.success('Success', 'Payment method updated successfully');
      
      this.paymentService.getPaymentType(true).then(() => {
      });
      
      return;
    }

    if (this.paymentService.SelectedPaymentTypes.CanSavePayments) {
      this.paymentService.OldSelectedPaymentType = this.paymentService.SelectedPaymentTypes;
      this.paymentService.getPaymentData(paymentData).then(() => {
        this.paymentService.getPaymentType();
        if (this.paymentService.SelectedPaymentTypes && this.paymentService.SelectedPaymentTypes.PaymentMethodId) {
          this.persistentService.retailData.SelectedAutoshipPayment = {
            ...this.paymentService.SelectedPaymentTypes,
            PaymentTypeID: this.paymentService.SelectedPaymentTypes.PaymentMethodId,
            PaymentDisplay: (this.paymentService.SelectedPaymentTypes.DisplayName || this.paymentService.SelectedPaymentTypes.CardType) + 
                           ' ' + (this.paymentService.SelectedPaymentTypes.Ending || '')
          };
        }
      });
    } else {
      this.paymentService.oldSelectedPaymentTypeName = this.paymentService.selectedPaymentTypeName;
      this.userService.paymentMethods = [];
      const paymentMethodId = this.paymentService.SelectedPaymentTypes.PaymentMethodId || '';
      
      const selectpay = {
        CardType: this.paymentService.SelectedPaymentTypes.CardType || this.paymentService.SelectedPaymentTypes.Name,
        Ending: this.paymentService.SelectedPaymentTypes.Ending,
        Last4: this.paymentService.SelectedPaymentTypes.Ending,
        Expires: this.paymentService.SelectedPaymentTypes.Expires,
        ExpireMonth: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('M') : 0,
        ExpireYear: this.paymentService.SelectedPaymentTypes.Expires ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('YYYY') : 0,
        NameOnAccount: this.paymentService.SelectedPaymentTypes.NameOnAccount || this.paymentService.SelectedPaymentTypes.Name,
        Token: paymentMethodId,
        PaymentMethodId: paymentMethodId,
        MerchantId: this.paymentService.SelectedPaymentTypes.MerchantId
      };
      this.userService.paymentMethods.push(selectpay);
      this.userService.isPaymentChanged = true;
      
      this.persistentService.retailData.SelectedAutoshipPayment = {
        ...this.paymentService.SelectedPaymentTypes,
        PaymentTypeID: paymentMethodId,
        PaymentDisplay: (this.paymentService.SelectedPaymentTypes.DisplayName || this.paymentService.SelectedPaymentTypes.CardType || this.paymentService.SelectedPaymentTypes.Name) + 
                       ' ' + (this.paymentService.SelectedPaymentTypes.Ending || '')
      };
    }
    localStorage.setItem('userService', JSON.stringify(this.userService));
  }

  // delete Payment Method
  removeCardDetail(payment) {
    const messageText = this.translate.instant('confirm_delete_payment_info') + ' ' + this.getPaymentDescription(payment) + '?';
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: {
        title: '',
        message: messageText,
        takeaction: this.translate.instant('Delete'),
        noaction: this.translate.instant('cancel'),
      },
      panelClass: '',
      disableClose: true
    });
    dialog.afterClosed().subscribe((data) => {
      this.deleteCreditCard(payment);
      this.persistentService.retailData.isChanged = true;
    });
  }

  increaseItemQuantiy(type, item) {
    this.cart1Service.increaseQuantiy(item, type == 'autoship', type == 'pack',true);
  }

 decreaseItemQuantiy(type, item) {
    this.cart1Service.decreaseQuantiy(item, type == 'autoship', type == 'pack',true);
  }

  getPaymentMethodDisplayName(payment: any): string {
    if (payment.MerchantId === 5) {
      return 'New Credit Card';
    } else if (payment.MerchantId === EWALLET_MERCHANT_ID) {
      return 'E-Wallet';
    } else {
      return payment.DisplayName || payment.Name || 'Payment Method';
    }
  }

  getPaymentDescription(payment) {
    if (!payment) {
      return '';
    }
    if (payment.CreditCardTypeDescription === 'Unknown') {
      return payment.CreditCardTypeDescription;
    }
    const type = payment.CreditCardTypeDescription || payment.Name || payment.CardType;
    const numb = payment.CreditCardNumberDisplay || new AddSymbolWithNumberPipe().transform(payment.Ending, '*', 4, 11) ||
      new AddSymbolWithNumberPipe().transform(payment.Last4, '*', 4, 11);
    return type + ' ' + numb;
  }

  deleteCreditCard(payment) {
    const DeleteCreditCardRequest = {
      customerId: this.userService.customerData.CustomerId,
      merchantid: payment.MerchantId,
      paymentmethodid: payment.PaymentMethodId
    };
    this.apiService
      .deletePaymentMethod(DeleteCreditCardRequest).subscribe((result) => {
        try {
          if (parseInt(result.Status, 10) === 0) {
            if (this.paymentService.selectedPaymentTypeName == (payment.Name + ' ' + payment.Ending)) {
              this.paymentService.SelectedPaymentTypes = {};
              this.userService.paymentMethods = [];
              this.paymentService.selectedPaymentTypeName = '';
              this.paymentService.selectedPaymentTypeName = this.translate.instant('Add_Payment_Method');
            }
            this.notificationService.success('Success', this.translate.instant('successfully_deleted'));
            this.paymentService.getPaymentType();
          } else {
            this.notificationService.error('Error', (result.Message ? result.Message : this.translate.instant('not_remove')));
          }
        } catch (ex) {
          // Handle exception silently
        }
      }, (error) => {
        this.notificationService.error('Error', this.translate.instant('not_remove'));
      },
        () => {
        });
  }

  getDisplayValue() {
    if (this.userService.paymentMethods.length > 0) {
      const method = this.userService.paymentMethods[0];
      if (method.MerchantId === EWALLET_MERCHANT_ID) {
        return 'E-Wallet';
      } else {
        return `${method.CardType} •••• ${method.Ending}`;
      }
    }
    return '';
  }

  // Format expiration date correctly using UTC to avoid timezone issues
  formatExpirationDate(expires: any): string {
    if (!expires) return '';
    
    try {
      const date = new Date(expires);
      if (!isNaN(date.getTime())) {
        // Use UTC methods to avoid timezone conversion issues
        const month = date.getUTCMonth() + 1;
        const year = date.getUTCFullYear();
        return `${month.toString().padStart(2, '0')}/${year}`;
      }
    } catch (error) {
      // Error formatting expiration date
    }
    
    return '';
  }

  addAutoshipItem() {
    const autoshipId = this.editingAutoship.AutoShipID || this.selectedAutoship || this.getAutoshipOrderDetail?.id;
    const autoshipText = this.translate.instant('add_to_autoship_and_checkout') + ' ' + '#' + autoshipId + ' ' + '?';
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: {
        title: autoshipText,
        message: '',
        takeaction: this.translate.instant('okay_to_shopping'),
        noaction: this.translate.instant('cancel'),
      },
      panelClass: '',
      disableClose: true
    });
    dialog.afterClosed().subscribe((data) => {
      if (data) {
        this.persistentService.retailData.isChanged = true;
        this.persistentService.retailData.AddMoreItemInAutoshipFlag = true;
        this.persistentService.retailData.AddMoreItemInAutoshipData = this.getAutoshipOrderDetail;
        // Preserve the autoship ID for sidecart navigation
        this.persistentService.retailData.CurrentSelectedAutoOrder = autoshipId;
        // Save to localStorage so it survives page refresh
        this.persistentService.setRetailData();
        // Set the marketplace store ID in session storage and navigate to marketplace
        sessionStorage.setItem('selectedStoreId', this.storeConstantsService.getCurrentStoreConstants().MARKETPLACESTORE);
        this.router.navigate(['/marketplace']);
      }
    });
  }

  /**
   * ========================================
   * PAYMENT METHOD MANAGEMENT SECTION
   * ========================================
   * This section handles adding and changing payment methods for autoship orders.
   * It mirrors the functionality from the checkout page to maintain consistency.
   */

  /**
   * Add New Payment Method
   * Called when user clicks "Add Payment Method" button (shown when no payment method exists)
   * Opens the payment method selection dialog with E-Wallet option included
   */
  addNewPaymentMethod() {
    this.showPaymentMethodSelectionDialogForNewPayment();
  }

  /**
   * Change Payment Method
   * Called when user clicks "Change Payment Method" button (shown when payment method exists)
   * Loads customer's saved payment methods and shows selection dialog
   */
  changePaymentMethod() {
    // Check if customer is logged in
    if (this.userService.customerData.CustomerId) {
      // Prepare request to get saved payment methods
      const request = {
        customerId: this.userService.customerData.CustomerId
      };
      
      // Call API to get customer's saved payment methods
      this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
        (result) => {
          try {
            // Check if API call was successful and returned data
            if (result.Message === "Success" && result.Data && result.Data.length > 0) {
              // Add E-Wallet option to the existing saved payment methods
              const paymentMethodsWithEwallet = this.addEwalletOption(result.Data);
              
              // Show payment method selection dialog with saved methods + E-Wallet
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            } else {
              // No saved payment methods found, show dialog with only E-Wallet option
              const paymentMethodsWithEwallet = this.addEwalletOption([]);
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            }
          } catch (ex) {
            // Handle any exceptions during data processing
            const paymentMethodsWithEwallet = this.addEwalletOption([]);
            this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
          }
        },
        (error) => {
          // Handle API call errors - still show dialog with E-Wallet option
          const paymentMethodsWithEwallet = this.addEwalletOption([]);
          this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
        }
      );
    } else {
      // Customer not logged in, show dialog with only E-Wallet option
      const paymentMethodsWithEwallet = this.addEwalletOption([]);
      this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
    }
  }

  /**
   * Show Payment Method Selection Dialog for New Payments
   * Similar to changePaymentMethod but specifically for adding new payment methods
   * Ensures E-Wallet is always available as an option
   */
  showPaymentMethodSelectionDialogForNewPayment() {
    // Check if customer is logged in
    if (this.userService.customerData.CustomerId) {
      // Prepare request to get saved payment methods
      const request = {
        customerId: this.userService.customerData.CustomerId
      };
      
      // Call API to get customer's saved payment methods
      this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
        (result) => {
          try {
            // Check if API call was successful and returned data
            if (result.Message === "Success" && result.Data && result.Data.length > 0) {
              // Add E-Wallet option to the existing saved payment methods
              const paymentMethodsWithEwallet = this.addEwalletOption(result.Data);
              
              // Show payment method selection dialog with saved methods + E-Wallet
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            } else {
              // No saved payment methods found, show dialog with only E-Wallet option
              const paymentMethodsWithEwallet = this.addEwalletOption([]);
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            }
          } catch (ex) {
            // Handle any exceptions during data processing
            const paymentMethodsWithEwallet = this.addEwalletOption([]);
            this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
          }
        },
        (error) => {
          // Handle API call errors - still show dialog with E-Wallet option
          const paymentMethodsWithEwallet = this.addEwalletOption([]);
          this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
        }
      );
    } else {
      // Customer not logged in, show dialog with only E-Wallet option
      const paymentMethodsWithEwallet = this.addEwalletOption([]);
      this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
    }
  }

  /**
   * Add E-Wallet Option to Payment Methods
   * Ensures E-Wallet is always available as a payment option
   * @param paymentMethods - Array of existing payment methods
   * @returns Array with E-Wallet option added if not already present
   */
  addEwalletOption(paymentMethods: any[]): any[] {
    // Check if E-Wallet is already in the payment methods list
    const hasEwallet = paymentMethods.some(method => method.MerchantId === EWALLET_MERCHANT_ID);
    
    // If E-Wallet is not present, add it to the beginning of the list
    if (!hasEwallet) {
      const ewalletMethod = {
        MerchantId: EWALLET_MERCHANT_ID,           // E-Wallet merchant ID constant
        Name: 'E-Wallet',                         // Display name
        CardType: 'E-Wallet',                     // Card type for display
        DisplayName: 'E-Wallet',                  // Display name for UI
        PaymentMethodId: EWALLET_MERCHANT_ID.toString(), // Payment method ID
        CanSavePayments: true                      // Can be saved as payment method
      };
      // Add E-Wallet to the beginning of the array (highest priority)
      paymentMethods.unshift(ewalletMethod);
    }
    
    return paymentMethods;
  }

  /**
   * Show Payment Method Selection Dialog
   * Opens the payment method selection dialog component
   * @param savedPaymentMethods - Array of saved payment methods to display
   */
  showPaymentMethodSelectionDialog(savedPaymentMethods?: any[]) {
    // Open the payment method selection dialog
    const dialogRef = this.dialog.open(PaymentMethodSelectionDialogComponent, {
      width: '500px',                              // Dialog width
      data: {
        allowedMethods: savedPaymentMethods || [],  // Payment methods to show
        isChangeMode: true,                         // Indicates this is for changing payment method
        currentPaymentMethod: this.userService.paymentMethods[0] // Currently selected payment method
      }
    });

    // Handle dialog result when user selects a payment method or wants to add new
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.action === 'addNew') {
          // User wants to add a new payment method - open payment form dialog
          this.openPaymentMethodDialog();
        } else {
          // User selected an existing payment method, save it using existing method
          this.addSavePayment(result);
        }
      }
    });
  }

  /**
   * Open Payment Method Dialog
   * Opens the actual payment method form dialog for adding new payment methods
   */
  openPaymentMethodDialog() {
    // First, get available payment types to determine which payment method to add
    this.paymentService.getPaymentType(true).then(() => {
      if (this.paymentService.PaymentTypeResponse['AllowedMethods'] && 
          this.paymentService.PaymentTypeResponse['AllowedMethods'].length > 0) {
        
        // Get the first available payment method (usually credit card)
        const firstPaymentMethod = this.paymentService.PaymentTypeResponse['AllowedMethods'][0];
        
        const getPaymentDataRequest = {
          countrycode: this.configService.commonData.selectedCountry || 'us',
          merchantid: firstPaymentMethod.MerchantId || 0,
          customerId: this.userService.customerData.CustomerId || ""
        };
        
        this.apiService.getPaymentMethodIFrame(getPaymentDataRequest).subscribe(
          (result) => {
            try {
              if (Number(result.Status) === 0) {
                const paymentData = result.Data;
                
                if (!paymentData) {
                  this.notificationService.error('Error', 'Unable to load payment form');
                  return;
                }
                
                const iframeWidth = paymentData?.Width || '720px';
                const iframeHeight = paymentData?.Height || '600px';
                const iframeUrl = paymentData?.IFrameUrl || paymentData;
                
                // Open the hosted payment dialog with the proper data
                const dialogRef = this.dialog.open(HostedpaymentDialogComponent, {
                  width: '600px',
                  data: {
                    IFrameUrl: iframeUrl,
                    Width: iframeWidth,
                    Height: iframeHeight,
                    isAutoship: true,                   // Indicates this is for autoship
                    customerId: this.userService.customerData.CustomerId
                  },
                  panelClass: 'hosted_payment-Dialog'
                });

            dialogRef.afterClosed().subscribe((dialogResult) => {
              if (dialogResult) {
                let paymentData = null;
                
                if (dialogResult === true) {
                  this.refreshPaymentMethods();
                  return;
                }
                
                if (typeof dialogResult === 'object') {
                  if (dialogResult.success && dialogResult.data) {
                    paymentData = dialogResult.data;
                  } else if (dialogResult.data && !dialogResult.success) {
                    paymentData = dialogResult.data;
                  } else if (dialogResult.token || dialogResult.Token || dialogResult.PaymentMethodId || 
                             dialogResult.paymentMethodId || dialogResult.lastFour || dialogResult.last4) {
                    paymentData = dialogResult;
                  }
                }
                
                if (paymentData && typeof paymentData === 'object' && Object.keys(paymentData).length > 0) {
                  const hasPaymentIdentifier = paymentData.token || paymentData.Token || 
                                               paymentData.PaymentMethodId || paymentData.paymentMethodId ||
                                               paymentData.lastFour || paymentData.last4;
                  
                  if (hasPaymentIdentifier) {
                    this.processNewPaymentMethodFromDialog(paymentData, firstPaymentMethod);
                  } else {
                    this.refreshPaymentMethods();
                  }
                } else {
                  this.refreshPaymentMethods();
                }
              }
            });
              } else {
                this.notificationService.error('Error', result.ErrorDescription || 'Unable to load payment form');
              }
            } catch (ex) {
              console.error('Error opening payment dialog:', ex);
              this.notificationService.error('Error', 'Unable to load payment form');
            }
          },
          (error) => {
            console.error('Error getting payment iframe data:', error);
            this.notificationService.error('Error', 'Failed to load payment data');
          }
        );
      } else {
        this.notificationService.error('Error', 'No payment methods available');
      }
    }).catch((error) => {
      this.notificationService.error('Error', 'Failed to load payment types');
    });
  }

  processNewPaymentMethodFromDialog(paymentData: any, paymentMethodType: any) {
    try {
      const newPayment: any = {
        ...paymentData,
        MerchantId: paymentMethodType.MerchantId || paymentData.MerchantId
      };
      
      const lastFour = paymentData.lastFour || paymentData.Last4 || paymentData.Ending || '';
      if (paymentData.type) {
        newPayment.CardType = paymentData.type;
        if (paymentData.type.toLowerCase().includes('mastercard') || paymentData.type.toLowerCase().includes('master')) {
          newPayment.CardType = 'MasterCard';
        } else if (paymentData.type.toLowerCase().includes('visa')) {
          newPayment.CardType = 'Visa';
        } else if (paymentData.type.toLowerCase().includes('amex') || paymentData.type.toLowerCase().includes('american')) {
          newPayment.CardType = 'Amex';
        } else if (paymentData.type.toLowerCase().includes('discover')) {
          newPayment.CardType = 'Discover';
        }
      } else if (lastFour && lastFour.length >= 4) {
        const firstDigit = lastFour.charAt(0);
        if (firstDigit === '4') {
          newPayment.CardType = 'Visa';
        } else if (firstDigit === '5' || firstDigit === '2') {
          newPayment.CardType = 'MasterCard';
        } else if (lastFour.substring(0, 2) === '34' || lastFour.substring(0, 2) === '37') {
          newPayment.CardType = 'Amex';
        } else if (firstDigit === '6') {
          newPayment.CardType = 'Discover';
        } else {
          newPayment.CardType = paymentData.CardType || 'Credit Card';
        }
      } else {
        newPayment.CardType = paymentData.CardType || 'Credit Card';
      }
      
      newPayment.Ending = paymentData.lastFour || paymentData.Last4 || paymentData.Ending || '';
      newPayment.Last4 = newPayment.Ending;
      newPayment.CreditCardTypeDescription = newPayment.CardType;
      newPayment.CreditCardNumberDisplay = '****' + newPayment.Ending;
      
      let month = paymentData.expireMonth || paymentData.ExpireMonth;
      let year = paymentData.expireYear || paymentData.ExpireYear;
      
      if (typeof month === 'string') {
        month = parseInt(month.replace(/[^\d]/g, ''), 10);
      }
      if (typeof year === 'string') {
        year = year.replace(/[^\d]/g, '');
        if (year.length === 2) {
          year = 2000 + parseInt(year, 10);
        } else {
          year = parseInt(year, 10);
        }
      } else if (typeof year === 'number') {
        if (year < 100) {
          year = 2000 + year;
        }
      }
      
      newPayment.ExpireMonth = month || 0;
      newPayment.ExpireYear = year || 0;
      
      if (newPayment.ExpireMonth && newPayment.ExpireYear) {
        const monthNum = parseInt(newPayment.ExpireMonth.toString(), 10);
        const yearNum = parseInt(newPayment.ExpireYear.toString(), 10);
        
        if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && 
            !isNaN(yearNum) && yearNum >= new Date().getFullYear() && yearNum <= new Date().getFullYear() + 20) {
          newPayment.Expires = new Date(Date.UTC(yearNum, monthNum - 1, 1));
        } else {
          newPayment.Expires = null;
        }
      } else {
        newPayment.Expires = null;
      }
      
      const firstName = paymentData.billingInfo?.firstName || '';
      const lastName = paymentData.billingInfo?.lastName || '';
      const fullName = firstName && lastName ? `${firstName} ${lastName}` : (paymentData.billingInfo?.fullName || '');
      
      newPayment.NameOnAccount = fullName || paymentData.NameOnAccount || paymentData.Name || '';
      newPayment.Token = paymentData.token || paymentData.Token || paymentData.PaymentMethodId || paymentData.paymentMethodId || '';
      newPayment.token = newPayment.Token;
      newPayment.PaymentMethodId = paymentData.PaymentMethodId || paymentData.paymentMethodId || newPayment.Token;
      newPayment.DisplayName = newPayment.CardType + ' ' + newPayment.Ending;
      
      if (paymentData.billingInfo) {
        newPayment.BillingAddress = paymentData.billingInfo.address?.address || paymentData.billingInfo.address || '';
        newPayment.BillingCity = paymentData.billingInfo.address?.city || '';
        newPayment.BillingState = paymentData.billingInfo.address?.state || '';
        newPayment.BillingZip = paymentData.billingInfo.address?.zip || paymentData.billingInfo.address?.postalCode || '';
        newPayment.BillingCountry = paymentData.billingInfo.address?.country || '';
      }
      
      const mappedPaymentMethod = this.mapPaymentMethodForAutoship(newPayment);
      
      if (!mappedPaymentMethod.CardType) {
        mappedPaymentMethod.CardType = newPayment.CardType || 'Credit Card';
      }
      if (!mappedPaymentMethod.Ending) {
        mappedPaymentMethod.Ending = newPayment.Ending || '';
      }
      if (!mappedPaymentMethod.Expires && newPayment.Expires) {
        mappedPaymentMethod.Expires = newPayment.Expires;
      }
      if (!mappedPaymentMethod.NameOnAccount) {
        mappedPaymentMethod.NameOnAccount = newPayment.NameOnAccount || '';
      }
      
      const paymentMethodsArray = [mappedPaymentMethod];
      this.userService.paymentMethods = paymentMethodsArray;
      this.user.userServiceModal.paymentMethods = paymentMethodsArray; // Also update the source
      this.userService.isPaymentChanged = true;
      this.user.userServiceModal.isPaymentChanged = true;
      
      this.paymentService.SelectedPaymentTypes = mappedPaymentMethod;
      this.paymentService.selectedPaymentTypeName = mappedPaymentMethod.CardType + ' ' + mappedPaymentMethod.Ending;
      
      this.persistentService.retailData.SelectedAutoshipPayment = {
        ...mappedPaymentMethod,
        PaymentTypeID: mappedPaymentMethod.PaymentMethodId || mappedPaymentMethod.Token,
        PaymentDisplay: mappedPaymentMethod.CardType + ' ' + mappedPaymentMethod.Ending,
        PaymentMethodID: mappedPaymentMethod.PaymentMethodId || mappedPaymentMethod.Token,
        PaymentMerchantID: mappedPaymentMethod.MerchantId,
        ExpireMonth: mappedPaymentMethod.ExpireMonth,
        ExpireYear: mappedPaymentMethod.ExpireYear
      };
      
      this.persistentService.retailData.isChanged = true;
      
      localStorage.setItem('userService', JSON.stringify(this.userService));
      
      this.cdr.detectChanges();
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 100);
      
      this.notificationService.success('Success', 'Payment method added successfully');
      
      setTimeout(() => {
        this.refreshPaymentMethodsSilently();
      }, 2000);
      
    } catch (ex) {
      console.error('Error processing payment method from dialog:', ex);
      this.notificationService.error('Error', 'Failed to add payment method. Please try again.');
    }
  }

  refreshPaymentMethodsSilently() {
    if (!this.userService.customerData.CustomerId) {
      return;
    }

    const request = {
      customerId: this.userService.customerData.CustomerId
    };
    
    this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
      (result) => {
        try {
          const isSuccess = (result && parseInt(result.Status, 10) === 0) || (result && result.Message === "Success");
          
          if (isSuccess && result.Data && Array.isArray(result.Data) && result.Data.length > 0) {
            this.paymentService.PaymentTypeResponse['SaveMethods'] = result.Data;
          }
        } catch (ex) {
        }
      },
      (error) => {
      }
    );
  }

  /**
   * Refresh Payment Methods
   * Reloads the customer's saved payment methods after adding a new one
   */
  refreshPaymentMethods() {
    if (!this.userService.customerData.CustomerId) {
      this.notificationService.error('Error', 'Customer ID is missing');
      return;
    }

    setTimeout(() => {
      const request = {
        customerId: this.userService.customerData.CustomerId
      };
      
      this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
        (result) => {
          try {
            const isSuccess = (result && parseInt(result.Status, 10) === 0) || (result && result.Message === "Success");
            
            if (isSuccess && result.Data && Array.isArray(result.Data) && result.Data.length > 0) {
              // Update the payment service with new payment methods
              this.paymentService.PaymentTypeResponse['SaveMethods'] = result.Data;
              
              // Add E-Wallet option
              const paymentMethodsWithEwallet = this.addEwalletOption(result.Data);
              
              // Select the first payment method (most recently added)
              if (paymentMethodsWithEwallet.length > 0) {
                const mappedPaymentMethod = this.mapPaymentMethodForAutoship(paymentMethodsWithEwallet[0]);
                this.addSavePayment(mappedPaymentMethod);
                
                this.cdr.detectChanges();
                
                this.notificationService.success('Success', 'Payment method added successfully');
              } else {
                this.notificationService.warning('Warning', 'No payment methods found');
              }
            } else {
              const errorMsg = result?.Message || 'Unable to load payment information';
              if (!this.userService.paymentMethods || this.userService.paymentMethods.length === 0) {
                this.notificationService.error('Error', errorMsg);
              }
            }
          } catch (ex) {
            console.error('Error processing payment methods:', ex);
            this.notificationService.error('Error', 'Error processing payment methods');
          }
        },
        (error) => {
          console.error('Error refreshing payment methods:', error);
          if (!this.userService.paymentMethods || this.userService.paymentMethods.length === 0) {
            this.notificationService.error('Error', 'Unable to load payment information. Please refresh the page.');
          }
        }
      );
    }, 1500); 
  }

  mapPaymentMethodForAutoship(paymentMethod: any): any {
    return {
      ...paymentMethod,
      CardType: paymentMethod.CardType || paymentMethod.Name || paymentMethod.CreditCardTypeDescription || 'Credit Card',
      Ending: paymentMethod.Ending || paymentMethod.Last4 || paymentMethod.CreditCardNumberDisplay || '',
      Last4: paymentMethod.Ending || paymentMethod.Last4 || paymentMethod.CreditCardNumberDisplay || '',
      PaymentMethodId: paymentMethod.PaymentMethodId || paymentMethod.PaymentMethodID || '',
      Token: paymentMethod.PaymentMethodId || paymentMethod.PaymentMethodID || paymentMethod.Token || '',
      MerchantId: paymentMethod.MerchantId || paymentMethod.MerchantID,
      NameOnAccount: paymentMethod.NameOnAccount || paymentMethod.Name || paymentMethod.CardholderName || '',
      DisplayName: paymentMethod.DisplayName || paymentMethod.CardType || paymentMethod.Name,
      Expires: paymentMethod.Expires || null,
      ExpireMonth: paymentMethod.ExpireMonth || (paymentMethod.Expires ? new Date(paymentMethod.Expires).getMonth() + 1 : 0),
      ExpireYear: paymentMethod.ExpireYear || (paymentMethod.Expires ? new Date(paymentMethod.Expires).getFullYear() : 0)
    };
  }

  autoshipChanged() {
    return this.persistentService.retailData.isChanged;
  }

  getCvv(data) {
    if (data) {
      this.placeAutoOrder(data);
    } else {
      this.isDisabledCreateOrder = false;
    }
  }

  updateAutoOrder() {
    this.isDisabledCreateOrder = true;
    if (this.user.checkIfUserAuthenticatedOrNot()) {
      // Check if payment method requires CVV validation (same logic as checkout component)
      const cvvMerchantIds = this.configService.localSettings.Global.CVVRequiredMerchantIds || CVV_REQUIRED_MERCHANT_IDS;
      const showCvv = cvvMerchantIds.split(',').filter((item) => {
        return item && item == this.paymentService.SelectedPaymentTypes.MerchantId;
      }).length;
      
      if (
        this.paymentService.SelectedPaymentTypes && Object.keys(this.paymentService.SelectedPaymentTypes).length &&
        this.userService.paymentMethods.length && 
        this.configService.localSettings.Global.AllowCVVModel &&
        (showCvv)
      ) {
        const dialog = this.dialog.open(AllowCvvComponent, {
          disableClose: true,
          panelClass: 'allowCvvModel-dialog'
        });
        dialog.afterClosed().subscribe((data) => {
          this.getCvv(data);
        });
      } else {
        this.placeAutoOrder();
      }
    }
    else {
      this.accountService.logout();
      this.login();

    }
  }

  login(){
    this.dialog.open(LoginDialogComponentComponent, {
      width: "600px",
      autoFocus:false
    });
  }

  placeAutoOrder(dataCvvCode?: any) {
    const placeOrderPromise = new Promise((resolve, reject) => {
      if (this.itemsService.selectedAutoOrderItems.length > 0 && this.persistentService.retailData.Autoship.FrequencyTypeID == undefined) {
        this.notificationService.error('error_', 'choose_frequency_sidecart');
        return;
      }

      if (this.itemsService.selectedAutoOrderItems.length == 0) {
        this.notificationService.error('error_', 'autoship_required_msg');
        return;
      }
      if (this.userService.paymentMethods.length > 0) {
        const paymentMethod = this.userService.paymentMethods[0];
        if (paymentMethod.Last4 || paymentMethod.Last4 === undefined || paymentMethod.Last4 === null || 
            paymentMethod.CardType === 'E-Wallet' || paymentMethod.MerchantId === EWALLET_MERCHANT_ID) {
          this.paymentService.IsFrameReload = false;
        } else {
          this.notificationService.error('error_', 'shop_please_add_payment');
          this.isDisabledCreateOrder = false;
          return;
        }
      } else {
        this.notificationService.error('error_', 'shop_please_add_payment');
        this.isDisabledCreateOrder = false;
        return;
      }

      if (this.isStateRestrict || (!Object.keys(this.userService.shippingAddress).length && !this.userService.shippingAddress.Street1)) {
        this.notificationService.error('error_', 'please_add_address');
        this.isDisabledCreateOrder = false;
        return;
      }

      const autoshipproductdetails: Array<Item> = [];
      _.each(this.itemsService.selectedAutoOrderItems, (item) => {
        if (parseInt(item.Quantity, 10) > 0) {
          autoshipproductdetails.push({
            ItemId: item.ItemID,
            IsReward: false,
            Quantity: item.Quantity
          });
        }
      });

      // Get the first available shipping method ID
      const firstShippingMethodId = this.orderService.calculateOrderResponse?.ShippingMethods?.[0]?.ShipMethodId || 
                                   this.userService.shippingMethods?.[0]?.ShipMethodId || 
                                   this.userService.shippingMethods?.[0]?.ShipMethodID || 
                                   DefaultShipMethodID;
      
      let paymentMethodId = '';
      let merchantId: any = '';
      
      if (this.userService.paymentMethods.length > 0) {
        const paymentMethod = this.userService.paymentMethods[0];
        
        merchantId = paymentMethod.MerchantId || this.paymentService.SelectedPaymentTypes?.MerchantId || '';
        
        const merchantIdNum = typeof merchantId === 'string' ? parseInt(merchantId, 10) : merchantId;
        const paymentMethodMerchantIdNum = typeof paymentMethod.MerchantId === 'string' 
          ? parseInt(paymentMethod.MerchantId, 10) 
          : paymentMethod.MerchantId;
        
        // For e-wallet (MerchantId 11), use the MerchantId as PaymentMethodId
        if (paymentMethodMerchantIdNum === EWALLET_MERCHANT_ID || merchantIdNum === EWALLET_MERCHANT_ID) {
          if (!merchantId || merchantIdNum !== EWALLET_MERCHANT_ID) {
            merchantId = EWALLET_MERCHANT_ID;
          }
          paymentMethodId = merchantId.toString();
        } else {
          // For other payment methods, use Token or PaymentMethodId
          paymentMethodId = paymentMethod.Token || paymentMethod.PaymentMethodId || this.paymentService.SelectedPaymentTypes?.PaymentMethodId || '';
        }
      } else {
        // Fallback to SelectedPaymentTypes if no payment methods in userService
        merchantId = this.paymentService.SelectedPaymentTypes?.MerchantId || '';
        
        const merchantIdNum = typeof merchantId === 'string' ? parseInt(merchantId, 10) : merchantId;
        
        if (merchantIdNum === EWALLET_MERCHANT_ID) {
          merchantId = EWALLET_MERCHANT_ID;
          paymentMethodId = merchantId.toString();
        } else {
          paymentMethodId = this.paymentService.SelectedPaymentTypes?.PaymentMethodId || '';
        }
      }
      
      if (!merchantId) {
        this.notificationService.error('error_', 'Payment method merchant ID is missing');
        this.isDisabledCreateOrder = false;
        return;
      }
      
      if (!paymentMethodId) {
        this.notificationService.error('error_', 'Payment method ID is missing');
        this.isDisabledCreateOrder = false;
        return;
      }

      // Ensure FirstName and LastName are strings, not objects (defensive validation)
      const firstName = String(this.userService.shippingAddress.FirstName || '').trim();
      const lastName = String(this.userService.shippingAddress.LastName || '').trim();
      const shipToName = (firstName + ' ' + lastName).trim() || '';

      this.updateAutoOrderRequest = {
          ShipMethodId: firstShippingMethodId,
          Frequency: this.persistentService.retailData.Autoship.FrequencyTypeID.toString() || 1,
          Items: autoshipproductdetails,
          MerchantId: merchantId,
          PaymentMethodId: paymentMethodId,
          ShippingAddress: {
            AddressId: 0,
            FirstName: firstName,
            LastName: lastName,
            ShipTo: shipToName,
            Street1: this.userService.shippingAddress.Street1 || '',
            Street2: this.userService.shippingAddress.Street2 || '',
            Street3: this.userService.shippingAddress.Street3 || '',
            Region: this.userService.shippingAddress.Region || '',
            City: this.userService.shippingAddress.City || '',
            PostalCode: this.userService.shippingAddress.PostalCode || '',
            CountryCode: this.userService.shippingAddress.CountryCode || DefaultCountry
          } as ShipAddress,
          StartDate: this.autoshipConfigurationService.autoshipDate,
        } as CreateAutoOrder;

      this.apiService.updateAutoship(this.getAutoshipOrderDetail.id, this.updateAutoOrderRequest).subscribe((result) => {
        this.isDisabledCreateOrder = false;
        if (result.Status === 0) {
          this.userService.newUser = false;
          try {

          }
          catch (ex) {
            // Handle exception silently
          }
          result.AutoOrderId = this.getAutoshipOrderDetail.id;
          localStorage.setItem('SubmitApplication', JSON.stringify(result));
          this.utilityService.setAutoshipEditFlag(false);
          this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
          this.persistentService.retailData.AddMoreItemInAutoshipData = {};
          this.persistentService.retailData.isChanged = false;
          this.userService.isAddressChanged = false;
          this.userService.isPaymentChanged = false;
          this.userService.isShipMethodChanged = false;
          this.persistentService.retailData.isNewAutoship = false;
          this.persistentService.retailData.editAutoshipItems = [];
          this.persistentService.retailData.AddMoreItemInAutoshipData = {};
          this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
          this.userService.isAddressChanged = false;
          if (result.RedirectUrl && result.RedirectUrl.length > 0) {
            window.location = result.RedirectUrl;
          }else{
            this.notificationService.success('Success',"Autoship updated successfully");
            this.router.navigate(['/account/autoship']);
          }
          //this.router.navigate(['/complete']);
        }
        else{
          this.notificationService.error('error_', this.translate.instant(result.Message));
        }
        resolve(result);
      }, (error) => {
        reject(this.translate.instant('some_error_occur_try_again'));
        this.isDisabledCreateOrder = false;
        this.notificationService.error('error_', this.translate.instant('some_error_occur_try_again'));
      }, () => { });
    });
    return placeOrderPromise;
  }
}
